import { LEAD_DETAILS_VERSION_KEY } from 'modules/Leads/constant'
import { LEAD_PREVIEW_ORDER_QUERY_PARAM } from './constants'
import { LEAD_ROUTE, LEAD_ROUTE_V2 } from './constants/url'
import { LeadDetailsDesignVersion } from 'components'

export const urlExists = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url, { method: 'HEAD' })
    return response.status === 200
  } catch (e) {
    return false
  }
}

export const getUrlParams = (key: string) => {
  const params = new URLSearchParams(location.search.substring(1))
  const val = params.get(key)
  return { [key]: val }
}

export const addNextUrl = (url: string) => {
  const { nextUrl } = getUrlParams('nextUrl')
  return `${url}?nextUrl=${nextUrl ? nextUrl : window.location.pathname}`
}

export const getHostname = () => `${window.location.protocol}//${window.location.hostname}`
/**
 *
 * While Switching to new lead route replace LEAD_ROUTE with LEAD_ROUTE_V2 and vice versa
 */

export const getLeadDetailsVersion = ({
  leadDetailsVersionPreference,
}: {
  leadDetailsVersionPreference: LeadDetailsDesignVersion
}): LeadDetailsDesignVersion => {
  if (typeof window === 'undefined') return leadDetailsVersionPreference // SSR safety

  const storedVersion = localStorage.getItem(LEAD_DETAILS_VERSION_KEY) as LeadDetailsDesignVersion | null

  // If found in localStorage, that always takes priority
  if (storedVersion) {
    return storedVersion
  }

  // If not found, initialize with the API preference
  localStorage.setItem(LEAD_DETAILS_VERSION_KEY, leadDetailsVersionPreference)

  // Return a normalized version
  return ['v2'].includes(leadDetailsVersionPreference) ? 'v2' : 'v1'
}

export const getLeadRoute = ({ leadId }: { leadId: string }) => `/${LEAD_ROUTE}${leadId}`

export const getLeadRouteV2 = ({ leadId }: { leadId: string }) => `/${LEAD_ROUTE_V2}${leadId}`

export const getPreviewLeadRouteV2 = ({
  leadId,
  orderedSectionsNames,
}: {
  leadId: string
  orderedSectionsNames: string
}) => `/preview/${LEAD_ROUTE_V2}${leadId}?${LEAD_PREVIEW_ORDER_QUERY_PARAM}=${orderedSectionsNames}`

export const isPreview = () => window.location.href?.includes('preview')

export const openNewTab = (url: string) => {
  window.open(`${url}${url.includes('?') ? '&' : '?'}inline=1`, '_blank')
}
